export default __webpack_public_path__ + "static/web-app-5dc270880f97176c0c0cd7f0f263a7a9.svg";